// extracted by mini-css-extract-plugin
export default {"wrapper":"srqImCNc1VJn3GU1X9kf","bordered":"xfaOgMaMV2KuJ4bw9k9u"};